import { render, staticRenderFns } from "./SolarwindsBackupWizard.vue?vue&type=template&id=56f17d81&"
import script from "./SolarwindsBackupWizard.vue?vue&type=script&lang=js&"
export * from "./SolarwindsBackupWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports